export const TableSkeletonCell = () => (
  <div className="msq-skeleton-text w-full max-w-[80px] h-4" />
);
